import React, { useState, useEffect, useMemo } from "react";
import { Box, CircularProgress, Chip, Accordion, AccordionSummary, Typography, AccordionDetails, Backdrop, Button, Container } from "@mui/material";
import { Typography as JoyTypography } from "@mui/joy";
import ApproverActionButtons from "../components/Employee/ApproverPage/ApproverActionButtons";
import EmployeeSidebar from "../components/EmployeeSidebar";
import { useParams, useNavigate } from "react-router-dom";
import { ThemeProvider as MaterialThemeProvider } from "@mui/material/styles";

import {
  useAgreedAndForwardInvoiceMutation,
  useChangeInvoiceStatusMutation,
  useGetEmployeeInvoiceDetailsQuery,
  useGetInvoiceDetailsQuery,
  useParkInvoiceBulkMutation,
  useParkInvoiceMutation,
  useRefetchApproverDataMutation,
} from "../services/invoices/InvoiceApiSlice";
import { useGetApiAssignToMutation, useGetApproverPageDetailsMutation, useGetVendorDetailsQuery, useGetVendorDetailsWithIdQuery } from "../services/vendor/VendorApi";
import { ChangeInvoiceStatusRequest, ParkInvoiceLineItem, ParkInvoiceRequest, InvoiceDetailLineItem } from "../utils/types";
import { BillEntryPage } from "../components/Employee/ApproverPage/BillEntryPage";
import ApproverPageTable from "../components/Employee/ApproverPage/ApproverPageTable";
import { toast, ToastContainer } from "react-toastify";
import ApproverModal from "../components/Employee/ApproverPage/ApproverModal";
import { ExpandMore, Refresh } from "@mui/icons-material";
import { Sheet } from "@mui/joy";
import DocumentTable from "../components/Common/DocumentsTable";
import ApprovalLogsDrowdown from "../components/Employee/ApproverPage/ApprovalLogsDrowdown";
import GRNActionModal from "../components/Employee/ApproverPage/GRNActionModal";
import SuccessModal from "../components/Common/SuccessModal";
import useAddEntryForm from "../hooks/useAddEntryForm";
import BtsFinancialDetailsSection from "../components/add-entry/BtsFinancialDetailsSection";
import { formatDateForInput } from "../utils/utils";
import AttachmentTable from "../components/add-entry/AttachmentTable";
import { TypographyInheritContext } from "@mui/joy/Typography/Typography";
import { muiThemeFinal } from "../utils/constants";
import VendorInfoCard from "../components/vendor-details/VendorInfoCard";
import EmployeeModal from "../components/add-entry/EmployeeModal";
import OtherAttachments from "../components/add-entry/OtherAttachments";

export const ApproverPage: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const navigate = useNavigate();
  const { id: routeIdParam1 } = useParams<{ id: string }>();
  var routeIdParam = atob(atob(routeIdParam1))
  const { handleFileDownload, sectionHeaderStyles, handleCurrencyOnBlur } = useAddEntryForm();
  const [sendAssignedTo] = useGetApiAssignToMutation();

  const [hntValue, setHntValue] = useState("");

  const current_vendor_id: any = localStorage.getItem("vendor_id");
  const { data: vendor_details } = useGetVendorDetailsWithIdQuery(current_vendor_id);

  const [assignto, setAssignto] = useState<string>("");
  const [approvalAction, setApprovalAction] = useState<string>("");
  const [selectedGRNData, setSelectedGRNData] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedLineItemIds, setSelectedLineItemIds] = useState<{ grn_no: string; line_item: string; index: any; batch_ses_no: string, RefDocIt: string, Lfbnr: string }[]>([]);
  const [successModalOpen, setSuccessModalOpen] = useState<{
    open: boolean;
    title?: string;
    description?: string;
  }>({
    open: false,
    title: "",
    description: "",
  });
  const [initialDocumentsData, setInitialDocumentsData] = useState([
    {
      id: "Inv",
      description: "Invoice",
      existingFileName: null,
    },
    {
      id: "lab",
      description: "Labor License",
      existingFileName: null,
    },
    {
      id: "wrk",
      description: "Work Completion Certificate",
      existingFileName: null,
    },
  ]);
  const { id } = useParams<{ id?: string }>();
  const btsNo = atob(atob(id));
  const [formData, setFormData] = useState<any>({
    attachment: null,
    attachmentPreview: null,
    throughGEM: "",
    gemContactNo: "",
    billType: "",
    billCategory: "",
    procurementType: "",
    poContract: "",
    vendor_code: "",
    vendor_name: "",
    dakNo: "",
    invoiceForWhichLocation: "",
    divisionName: "",
    remarks: "",
    btsNo: "System Generated",
    btsEntryDate: new Date().toISOString().slice(0, 10),
    grossAmount: "",
    billDate: "",
    totalTax: "",
    billAmount: "",
    billNo: "",
    advanceAdj: "",
    netPayable: "",
    isPoModuleSelected: "Yes",
    documents: initialDocumentsData.map((doc) => ({ ...doc })),
    poContractDetails: {
      plant: "",
      created_by: "",
      pending_with: "",
      responsible_person: "",
    },
    hnt_value: "",
    othersAttachments: [],
    posting_date: new Date().toISOString().slice(0, 10)
  });

  const responseVendorData = {
    companyName: vendor_details?.name || "",
    vendorNo: vendor_details?.lifnr || "",
    address: vendor_details?.streetHouse || "",
    panNoLabel: "Pan No.",
    panNoValue: vendor_details?.pan || "",
    bankKeyLabel: "Bank Key",
    bankKeyValue: vendor_details?.bankKey || "",
    gstLabel: "GST",
    gstValue: vendor_details?.taxNumber || "",
    accountNoLabel: "A/C",
    accountNoValue: vendor_details?.bankAccount || "",
  };

  const [dataApproverList, setDataApproverList] = useState(null);
  const [isRefreshed, setIsRefreshed] = useState<boolean>(false);
  const [isFI, setIsFI] = useState<boolean>(false);

  const {
    data: billsData,
    isLoading: isLoadingBillDetails,
    isError: isErrorBillDetails,
  } = useGetEmployeeInvoiceDetailsQuery(routeIdParam!, {
    skip: !routeIdParam,
    refetchOnMountOrArgChange: true,
  });
  const { data: invoiceDetails } = useGetInvoiceDetailsQuery(btsNo!, {
    skip: !btsNo,
  });
  useEffect(() => {
    setIsFI(billsData?.entry_type === "FI");
  }, [billsData]);

  useEffect(() => {
    const createDataUrl = (data: string | null, mime: string | null): string | null => {
      return data && mime ? `data:${mime};base64,${data}` : null;
    };

    if (invoiceDetails) {

      setFormData((prev) => ({
        ...prev,
        vendor_code: invoiceDetails?.vendor_code ?? "",
        vendor_name: invoiceDetails?.vendor_name ?? "",
        remarks: invoiceDetails.Remarks ?? "",
        throughGEM: invoiceDetails.gem_option ?? "",
        gemContactNo: invoiceDetails.gem_contact ?? "",
        advanceAdj: invoiceDetails.advance_adj ?? "",
        billAmount: invoiceDetails.bill_amount ?? "",
        billCategory: invoiceDetails.bill_category ?? "",
        billDate: formatDateForInput(invoiceDetails.bill_date),
        billType: invoiceDetails.bill_type ?? "",
        btsEntryDate: formatDateForInput(invoiceDetails.bts_entry_date),
        posting_date: formatDateForInput(invoiceDetails?.posting_date),
        btsNo: invoiceDetails.bts_no ?? "System Generated",
        dakNo: invoiceDetails.dak_no ?? "",
        divisionName: invoiceDetails.division_name ?? "",
        grossAmount: invoiceDetails.gross_amount ?? "",
        invoiceForWhichLocation: invoiceDetails.invoice_location ?? "",
        netPayable: invoiceDetails.net_payable ?? "",
        poContract: invoiceDetails.po_contract ?? "",
        assignedTo: invoiceDetails.pending_with ?? "",
        procurementType: invoiceDetails.procurement_type ?? "",
        totalTax: invoiceDetails.total_tax ?? "",
        billNo: invoiceDetails.challan_no ?? "",
        attachment: null,
        existingAttachmentName: invoiceDetails.attachment_name, // Store existing file name
        attachmentPreview: createDataUrl(invoiceDetails?.attachment_data, invoiceDetails?.attachment_mime),
        poContractDetails: {
          plant: invoiceDetails?.plant,
          created_by: invoiceDetails?.created_by,
          pending_with: invoiceDetails?.pending_with,
          responsible_person: invoiceDetails?.responsible_person,
        },
        documents: initialDocumentsData.map((doc) => {
          if (doc.description.toLowerCase().includes("labor")) {
            return {
              ...doc,
              file: null,
              existingFileName: invoiceDetails?.labor_name,
            };
          }
          if (doc.description.toLowerCase().includes("work completion")) {
            return {
              ...doc,
              file: null,
              existingFileName: invoiceDetails.workcert_name,
            };
          }
          return { ...doc };
        }),
        isPoModuleSelected: invoiceDetails.entry_type === "MM" ? "Yes" : "No",
        othersAttachments: [...invoiceDetails.othersAttachments]
      }));
    }
  }, [invoiceDetails]);

  const [getApproverPageData, { data: dataApproverListInitial, isLoading: isLoadingApproverPageData, isError: isErrorApproverPageData }] = useGetApproverPageDetailsMutation();

  const [refetchApproverData, { data: dataApproverListRefetch, isLoading: isLoadingApproverRefetchPageData, isError: isErrorApproverRefetchPageData }] = useRefetchApproverDataMutation();

  const [parkInvoiceAction, { isLoading: isParking }] = useParkInvoiceMutation();

  const [bulkParkInvoiceAction] = useParkInvoiceBulkMutation();

  const [changeInvoiceStatus, { isLoading: isChangingStatus }] = useChangeInvoiceStatusMutation();

  const [agreedAndForward] = useAgreedAndForwardInvoiceMutation();

  useEffect(() => {
    if (isRefreshed && !isErrorApproverRefetchPageData && !isErrorApproverRefetchPageData) {
      setDataApproverList(dataApproverListRefetch);
    } else if (!isLoadingApproverPageData && !isErrorApproverPageData && dataApproverListInitial) setDataApproverList(dataApproverListInitial);
  }, [dataApproverListInitial, dataApproverListRefetch]);

  useEffect(() => {
    setInitialDocumentsData([
      {
        id: "Inv",
        description: "Invoice",
        existingFileName: billsData?.attachment_name,
      },
      {
        id: "lab",
        description: "Labor License",
        existingFileName: billsData?.labor_name,
      },
      {
        id: "wrk",
        description: "Work Completion Certificate",
        existingFileName: billsData?.workcert_name,
      },
    ]);
  }, [billsData]);

  useEffect(() => {
    if (billsData && !isLoadingBillDetails && !isErrorBillDetails && billsData?.entry_type === "MM") {
      const payloadForApproverPage = {
        po_contract: billsData.po_contract || "",
        procurement_type: billsData.procurement_type || "",
        bill_type: billsData.bill_type || "",
        bill_category: billsData.bill_category || "",
        gross_amount: String(billsData.gross_amount || 0),
        total_tax: String(billsData.total_tax || 0),
        bill_amount: String(billsData.bill_amount || 0),
        bill_date: billsData.bill_date || "",
        challan_no: billsData.challan_no || "",
        bts_no: billsData?.bts_no || "",
      };

      if (invoiceDetails && invoiceDetails?.procurement_type !== "H") {
        getApproverPageData(payloadForApproverPage)
          .unwrap()
          .catch((err) => console.error("Error Fetching Approver Page Data:", err));
      }
    }
  }, [billsData, getApproverPageData, invoiceDetails]);

  const handleActualStatusChange = async (newStatus: string, remarks?: string) => {
    const invoiceIdToUpdate = billsData?.id;
    if (!invoiceIdToUpdate) {
      toast.error("Cannot change status: Invoice ID missing.");
      return;
    }

    const payload: ChangeInvoiceStatusRequest = {
      invoice_id: invoiceIdToUpdate,
      status: newStatus,
      ...(remarks ? { remarks } : {}),
    };
    try {
      const response = await changeInvoiceStatus(payload).unwrap();
      if (response.status === "Rejected") {
        toast.success(`Status updated to: ${response.status}`);
        navigate("/employee-bills");
      } else {
        toast.error(`Server error: ${response.message}`);
      }
    } catch (err) {
      console.error("Status Change Error:", err);
      toast.error("Error updating status. " + (err?.data?.message || err?.message));
    }
  };

  const handleSendAndAssign = async (action, remarks, selectedApproverId, selectedApproverDetails) => {
    const selectedItemsData = selectedGRNData;

    const payload = {
      invoice_id: String(billsData?.id),
      approver_name: selectedApproverDetails?.ename,
      pernr: selectedApproverId,
      approver_assigned: selectedApproverDetails?.username,
      approverremarks: remarks,
      hnt_value: hntValue,
    };
    const bulkParkPayload = selectedItemsData?.map((item, index) => {
      return {
        ...item,
        bts_no: billsData?.bts_no,
        total_amount: totalSelectedAmount,
      };
    });
    try {
      setIsLoading(true);
      const response = await agreedAndForward(payload).unwrap();
      if (response.success && !isFI) {
        const response = await bulkParkInvoiceAction({
          bts_no: billsData?.bts_no,
          data_to_insert: bulkParkPayload,
        }).unwrap();
      }
      setSuccessModalOpen({
        open: true,
        title: `Selected items forwarded successfully!`,
      });
      setSelectedLineItemIds([]);
    } catch (err: any) {

      let errMsg = "Error forwarding invoice.";
      if (err?.data?.message || err?.message) {
        errMsg = err?.data?.message || err?.message;
      }
      toast.error(errMsg);
    } finally {
      setIsLoading(false);
      setApprovalAction("");
    }
  };

  const handleInvoiceSelectValidation = async (id: string) => {
    if (!billsData) {
      toast.error("Main bill details are not available to park/forward.");
      console.error("handleParkInvoice: billsData is missing.");
      return;
    }
    if (!dataApproverList?.invoice_details_table || dataApproverList.invoice_details_table.length === 0) {
      toast.error("No line items available to select from for parking/forwarding.");
      console.error("handleParkInvoice: dataApproverList.invoice_details_table is missing or empty.");
      return;
    }
    if (selectedLineItemIds.length === 0) {
      toast.error("Please select at least one line item to park/forward.");
      return;
    }
    //  const selectedItemsData = dataApproverList?.invoice_details_table?.filter((item, index) =>
    //   selectedLineItemIds.some((selected) => selected?.grn_no === item?.grn_no && selected?.line_item === item?.line_item)
    // );

    const indexArr = selectedLineItemIds.map((item) => item?.index);
    const selectedItemsData = dataApproverList?.invoice_details_table?.filter((item, index) => indexArr?.includes(index));

    if (selectedItemsData?.length === 0 && selectedLineItemIds?.length > 0) {
      toast.error("Error: Could not find selected items in the current list. Please try re-selecting.");
      console.error("Mismatch between selectedLineItemIds and dataApproverList items. Check itemId logic.");
      return;
    }
    setSelectedGRNData(selectedItemsData);
    setApprovalAction(id);
  };


  const handleParkInvoiceSubmit = async () => {
    const selectedItemsData = selectedGRNData;

    const lineItemsToPark: ParkInvoiceLineItem[] = selectedItemsData?.map((item: InvoiceDetailLineItem) => ({
      po_no: item.po_no || "",
      line_item: item.line_item || "",
      grn_no: item.grn_no || "",
      doc_year: item.doc_year || "",
      amount: String(item.amount || "0.00"),
      bill_qty: String(item.bill_qty || "0"),
      tax_code: item.tax_code || "",
      Lfbnr: item.Lfbnr || "",
      Spos: item.Spos || "",
      RefDocIt: item.RefDocIt || "",
    }));

    const bulkParkPayload = selectedItemsData?.map((item, index) => {
      return {
        ...item,
        bts_no: billsData?.bts_no,
        total_amount: totalSelectedAmount,
      };
    });

    const parkPayload: ParkInvoiceRequest = {
      id: String(billsData.id || ""),
      invoices: lineItemsToPark,
      bill_date: formData.billDate || "",
      GrossAmount: String(formData?.grossAmount.replace(/,/g, "") || "0.00"),
      BtsNo: billsData.bts_no || "",
      posting_date: formData.posting_date,
      bill_No: formData?.billNo,
      total_tax: formData?.totalTax,
      bill_amount: formData?.billAmount,
      net_payable: formData?.netPayable,
    };

    try {
      setIsLoading(true);
      let res;
      if (!isFI) {
        res = await bulkParkInvoiceAction({
          bts_no: billsData?.bts_no,
          data_to_insert: bulkParkPayload,
        }).unwrap();
      }
      if (isFI || res?.status === "success") {
        if (isFI) {
          parkPayload.approver_code = localStorage.getItem("employee_id");
          parkPayload.FORWARDER_ID = localStorage.getItem("employee_id");
          // parkPayload.approver_code = selectedEmp.empCode;
          // parkPayload.FORWARDER_ID = selectedEmp.empCode;
        }

        const response: any = await parkInvoiceAction(parkPayload).unwrap();

        if (response?.success) {
          setSuccessModalOpen({
            open: true,
            title: `Selected items parked successfully! Invoice No.: ${response.invno}`,
          });
          setSelectedLineItemIds([]);
        } else {
          toast.error(response?.data?.message || response?.data?.message || response?.error);
        }
      } else {
        toast.error(`Failed to park invoice: ${res || "Unknown server error during parking."}`);
      }
    } catch (err: any) {

      let errorMessage = "An error occurred while parking the invoice.";
      if (err.data?.message || err?.data?.error) {
        errorMessage = err?.data?.message || err?.data?.error || err?.data?.message?.message;
      } else if (err?.message || err?.error) {
        errorMessage = err?.message || err?.error;
      }
      toast.error(JSON.stringify(errorMessage));
    } finally {
      setIsLoading(false);
    }
  };

  const handleRefreshClick = async () => {
    // const selectedItemsData = dataApproverList?.invoice_details_table?.map((item, index) => {
    //   return {
    //     grn_no: item?.grn_no,
    //     line_item: item?.line_item,
    //     index: index,
    //   };
    // });
    // setSelectedLineItemIds(selectedItemsData);
    setIsRefreshed(true);
    if (billsData) {
      const payloadForApproverPage = {
        po_contract: billsData.procurement_type === "H" ? hntValue : billsData.po_contract || "",
        procurement_type: billsData.procurement_type || "",
        bill_type: billsData.bill_type || "",
        bill_category: billsData.bill_category || "",
        gross_amount: String(billsData.gross_amount || 0),
        total_tax: String(billsData.total_tax || 0),
        bill_amount: String(billsData.bill_amount || 0),
        bill_date: billsData.bill_date || "",
        challan_no: billsData.challan_no || "",
      };
      refetchApproverData(payloadForApproverPage)
        .unwrap()
        .catch((err) => console.error("Error Fetching Approver Page Data:", err));
    }
  };

  const totalSelectedAmount = useMemo(() => {
    return (
      dataApproverList?.invoice_details_table?.reduce((sum, item) => {
        if (selectedLineItemIds.some((selected) => selected?.grn_no === item?.grn_no && selected?.line_item === item?.line_item)) {
          const amount = Number(item?.amount) || 0;
          const tax_amount = Number(item?.tax_amount) || 0;
          return sum + (amount + tax_amount);
        }
        return sum;
      }, 0) || 0
    );
  }, [dataApproverList?.invoice_details_table, selectedLineItemIds]);


  const actionHandlers = {
    onReject: () => setApprovalAction("Rejected"),
    onForward: () => (isFI ? setApprovalAction("assign-approver") : handleInvoiceSelectValidation("assign-approver")),
    // onParkInvoice: () => (isFI ? setIsOpen(true) : handleInvoiceSelectValidation("park-invoice")),
    onParkInvoice: () => (isFI ? setApprovalAction("park-invoice") : handleInvoiceSelectValidation("park-invoice")),
    onAssignto: () => { setIsOpen(true); setAssignto("assignto"); }
  };
  useEffect(() => {
    if (selectedEmp) {
      if (assignto === 'assignto') {
        onHandleSendToAssignedTo()
      } else {
        setApprovalAction("park-invoice");
      }
      setIsOpen(false);
    }
  }, [selectedEmp]);

  useEffect(() => {
    if (!isOpen) {
      setAssignto("");
    }
  }, [isOpen]);

  const onHandleSendToAssignedTo = async () => {
    try {

      const payload = {
        bts: invoiceDetails?.bts_no,
        body: { assign_to: selectedEmp.empUName, user_id: localStorage.getItem("employee_id"), user_name: localStorage.getItem("employee_name"), assign_to_name: selectedEmp.empName }
      }
      var toastId = toast.info("Send assign to " + selectedEmp.empName);
      const response = await sendAssignedTo(payload);
      if (response?.data?.success) {
        toast.dismiss(toastId);
        toast.success(response?.data?.message);
        navigate("/pending-bills");
      } else {
        toast.dismiss(toastId);
        toast.error(response?.data?.message);
      }

    } catch (err) {
      let errorMessage = "An error occurred.";
      if (err.data?.message || err?.data?.error) {
        errorMessage = err?.data?.message || err?.data?.error;
      } else if (err?.message || err?.error) {
        errorMessage = err?.message || err?.error;
      }
      toast.error(errorMessage);
    }
  }

  if (isErrorBillDetails)
    return (
      <Typography color="error" sx={{ p: 3 }}>
        Error loading data or no data found.
      </Typography>
    );



  return (
    <>
      <ToastContainer />
      <Box sx={{ display: "flex", minHeight: "100vh", background: 'white' }} className="approve-page-field">
        <EmployeeSidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 },
            overflow: "auto",
          }}
        >
          {/* Loading State */}
          <Backdrop
            sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
            open={(isLoadingApproverPageData && !dataApproverList) || isChangingStatus || isParking || isLoading || isLoadingBillDetails || isLoadingApproverRefetchPageData}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          {/* Header Data */}
          <>
            {billsData && (
              <JoyTypography level="title-lg" sx={sectionHeaderStyles} className="heading-1">
                Approver Workflow (BTS No.: {routeIdParam.replace(/^0+/, "")})
              </JoyTypography>
            )}
          </>

          {vendor_details && (
            <MaterialThemeProvider theme={muiThemeFinal}>
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: "var(--joy-palette-background-surface)" /* Use Joy CSS var */,
                }}
              >
                <VendorInfoCard vendor={responseVendorData} />
              </Box>
            </MaterialThemeProvider>
          )}

          {billsData && <AttachmentTable formData={formData} btsNo={invoiceDetails?.bts_no} handleFileChange={() => { }} handleFileClick={handleFileDownload} isReadOnly={true} />}
          <br />
          <>
            {billsData ? (
              <>
                <Sheet variant="outlined" sx={{ p: 0, borderRadius: "sm", overflow: "hidden" }}>
                  <JoyTypography level="title-lg" sx={sectionHeaderStyles} className="heading-1">
                    Header Details
                  </JoyTypography>
                  <BillEntryPage setHntValue={setHntValue} invoiceData={billsData} setDataApproverList={setDataApproverList} />
                </Sheet>

                <Sheet
                  variant="plain"
                  sx={{
                    p: 0,
                    borderRadius: "sm",
                    marginBottom: "30px",
                  }}
                >
                  {/* <DocumentTable handleFileClick={(doc) => handleFileDownload(doc, billsData?.bts_no)} initialDocumentsData={initialDocumentsData} /> */}
                </Sheet>

                <BtsFinancialDetailsSection
                  formData={formData}
                  handleCurrencyOnBlur={(e) => handleCurrencyOnBlur(e, setFormData)}
                  handleInputChange={(e) => {
                    const today = new Date();
                    const futureDate = new Date(e.target.value);
                    if (futureDate > today) {
                      toast.error("Future date not allow.");
                    } else {
                      setFormData({ ...formData, [e.target.name]: e.target.value })
                    }

                  }}
                  isReadOnly={false}
                  sectionHeaderStyles={sectionHeaderStyles}
                  approve={true}
                />
              </>
            ) : null}

          </>

          {/* GRN Table */}
          {billsData?.entry_type === "MM" ? (
            <>
              {isErrorApproverPageData || isErrorApproverRefetchPageData ? (
                <Typography color="error" sx={{ my: 2 }}>
                  Error loading GRN details.
                </Typography>
              ) : (
                <>
                  {dataApproverList?.invoice_details_table?.length >= 0 ? (
                    <Box
                      sx={{
                        p: "0",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button variant="outlined" size="small" sx={{ alignSelf: "flex-end", mb: "20px" }} onClick={handleRefreshClick}>
                        <Refresh />
                      </Button>

                      <ApproverPageTable
                        dataApproverList={dataApproverList}
                        selectedLineItemIds={selectedLineItemIds}
                        setSelectedLineItemIds={setSelectedLineItemIds}
                        totalSelectedAmount={totalSelectedAmount}
                        procurementType={formData?.procurementType}
                      />
                    </Box>
                  ) : (
                    <Typography sx={{ mb: "20px" }} style={{ textAlign: 'center', fontSize: '25px', color: 'red' }}>No GRN Data Found</Typography>
                  )}

                  {/* Action Buttons */}
                </>
              )}
            </>
          ) : null}

          <br />
          <OtherAttachments
            formData={formData}
            btsNo={invoiceDetails?.bts_no}
            handleFileChange={null}
            handleFileClick={handleFileDownload}
            onHandleDeleteRow={null}
            isReadOnly={true}
          />


          {billsData && (
            <ApproverActionButtons
              isForwardParkHidden={dataApproverList?.invoice_details_table?.length === 0 && billsData?.entry_type === "MM"}
              isForwardParkDisabled={billsData?.entry_type === "MM" && selectedLineItemIds?.length === 0}
              handlers={actionHandlers}
            />
          )}

          {/* Approval Logs */}
          {billsData && (
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1-content" id="panel1-header">
                <Typography component="span">Approval Logs</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ApprovalLogsDrowdown id={billsData?.id} />
              </AccordionDetails>
            </Accordion>
          )}

          {/* Modals */}
          <>
            <SuccessModal data={successModalOpen} setData={setSuccessModalOpen} handleClose={() => navigate("/employee-bills")} />
            <GRNActionModal
              open={["park-invoice", "assign-approver"]?.includes(approvalAction)}
              modalAction={approvalAction}
              isFI={isFI}
              onClose={() => {
                setApprovalAction("");
              }}
              billAmount={billsData?.bill_amount}
              totalSelectedAmount={totalSelectedAmount}
              handleInvoiceSubmit={approvalAction === "assign-approver" ? handleSendAndAssign : handleParkInvoiceSubmit}
              selectedEmp={selectedEmp}
            />
            {!["approval-logs", "park-invoice", "assign-approver"]?.includes(approvalAction) && (
              <ApproverModal modalAction={approvalAction} handleSubmit={handleActualStatusChange} setIsModalOpen={setApprovalAction} />
            )}
          </>
        </Box>
        {billsData?.entry_type && <EmployeeModal isOpen={isOpen} setIsOpen={setIsOpen} setSelectedEmp={setSelectedEmp} />}
      </Box>
    </>);
};
